var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 35,
    viewBox: "0 0 60 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31031 2.06287C2.31031 4.89622 1.87305 7.64561 1.87305 10.4802C1.87305 14.9419 1.95233 19.6201 3.29416 23.914C4.02139 26.2411 5.84961 28.4647 7.8976 29.7199C9.73033 30.8432 12.1115 30.9224 14.2137 30.9224C16.1229 30.9224 18.1732 30.6257 19.3637 28.9061C20.3881 27.4264 21.363 26.0228 22.0359 24.3148C22.5332 23.0523 22.6793 21.828 23.0804 20.5495C24.9317 14.6487 25.4854 8.65117 25.4854 2.50013",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4863 28.0681C36.232 28.7624 37.1922 29.1287 38.1189 29.5602C38.7172 29.8387 39.3169 30.1489 39.9502 30.3595C40.4883 30.5385 41.1193 30.8871 41.6734 30.9516C43.0474 31.1116 44.4197 31.1195 45.7748 30.8391C47.0968 30.5656 48.4506 30.0565 49.6791 29.5365C52.0715 28.5239 53.3417 25.8475 53.3417 23.4793C53.3417 22.0986 53.1282 20.7244 52.0827 19.6484C51.1693 18.7083 50.3216 18.0751 49.0559 17.5701C47.4497 16.9291 45.8078 16.4733 44.1215 16.0247C43.1671 15.7708 42.3072 15.4548 41.4 15.1128C40.6937 14.8466 40.1551 14.4236 39.4924 14.1063C38.2575 13.5149 37.0347 12.4849 36.5164 11.2642C35.7966 9.56868 35.534 7.44568 36.6373 5.84049C38.7891 2.70963 43.2703 2.06287 46.9575 2.06287C48.5915 2.06287 50.9863 2.56287 52.9863 4.06287",
    stroke: "#FF630B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.4c3e8fb8cb4413d6582393474ffe91c8.svg";
export { ForwardRef as ReactComponent };